const onEvent = (menuItemTitle) => {

  const menuItemData = menuItemTitle?.nextElementSibling;

  menuItemData?.style.setProperty('--openHeight', menuItemData?.scrollHeight + 'px');

  menuItemData?.classList.toggle('show');
  menuItemTitle?.classList.toggle('accordion_menu-item_active');
  menuItemTitle?.lastElementChild?.classList.toggle('icon-minus');
  menuItemData?.classList.toggle('hide');
};

const closeAccordions = (accordion, target) => {

  const accordionTitles = accordion.querySelectorAll('.accordion_menu-item_active');
  accordionTitles.forEach((item) => {
    if (target !== item) {
      onEvent(item);
    }
  });
};

const onAccordionsLoad = () => {
  const accordions = document.querySelectorAll('[data-accordion]');

  if (!accordions.length) return;

  accordions.forEach((item) => {
    item.addEventListener('click', (e) => {
      const targetEl = e.target?.closest('.accordion_menu-item');
      closeAccordions(item, targetEl);
      onEvent(targetEl);
    });

    item?.addEventListener('keydown', (e) => {
      const targetEl = e.target?.closest('.accordion_menu-item');
      if (e.key === 'Enter' || e.key === '') onEvent(targetEl);
    });
  });
};

export default onAccordionsLoad;
